<template>
  <div>
    <loading-content v-if="!allLoaded"/>
    <div v-else>
      <div v-if="!hasClaim">{{ translations.no_claim }}</div>
      <b-row v-else>
        <b-col cols="2">
          <b>{{ translations.first_name }}</b>
          <p>{{ claimInformation.first_name || '-' }}</p>
        </b-col>
        <b-col cols="2">
          <b>{{ translations.last_name }}</b>
          <p>{{ claimInformation.last_name || '-' }}</p>
        </b-col>
        <b-col cols="2">
          <b>{{ translations.member_insurance_id }}</b>
          <p>{{ claimInformation.member_insurance_number || '-' }}</p>
        </b-col>
        <b-col cols="2">
          <b>{{ translations.dob }}</b>
          <p>{{ claimInformation.dob || '-' }}</p>
        </b-col>
        <b-col cols="2">
          <b>{{ translations.claim_external_id }}</b>
          <p>{{ claimInformation.claim_external_id || '-' }}</p>
        </b-col>
        <b-col cols="2">
          <b>{{ translations.submitted_date }}</b>
          <p>{{ claimInformation.submitted_date || '-' }}</p>
        </b-col>
        <b-col cols="2">
          <b>{{ translations.billed_amount }}</b>
          <p>{{ claimInformation.billed_amount || '-' }}</p>
        </b-col>
        <b-col cols="2">
          <b>{{ translations.paid_amount }}</b>
          <p>{{ claimInformation.paid_amount || '-' }}</p>
        </b-col>
        <b-col cols="2">
          <b>{{ translations.claim_batch_id }}</b>
          <p>
            <router-link
            :to="{ name: 'FinanceClaimsBatchDetails', params: { claimsBatchID: claimInformation.claim_batch_id }}"
            target="_blank">
              {{ claimInformation.claim_batch_id || '-' }}
            </router-link>
          </p>
        </b-col>
        <b-col cols="2">
          <b>{{ translations.gender }}</b>
          <p>{{ claimInformation.gender || '-' }}</p>
        </b-col>
        <b-col cols="2">
          <b>{{ translations.relationship_to_insured }}</b>
          <p>{{ claimInformation.relationship_to_insured || '-' }}</p>
        </b-col>
        <b-col cols="2">
          <b>{{ translations.diagnosis_code }}</b>
          <p>{{ claimInformation.diagnosis_code || '-' }}</p>
        </b-col>
        <b-col cols="2">
          <b>{{ translations.pt_npi }}</b>
          <p>{{ claimInformation.pt_npi || '-' }}</p>
        </b-col>
        <b-col cols="12" class="mt-2">
          <financial-list
            :value="1"
            :header-data="CLAIM_TRANSACTIONS_TABLE_HEADERS"
            :data="claimTransactionTable"
            :havePagination="false"
            :no-items-message="translations.claim_transaction_table.empty"/>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import translations from '@/translations';
import FinancialList, { associateHeaderDataItem } from '@/components/Financial/FinancialList.vue';
import { formatDate, formatValue } from '@/helpers/finance';
import { parseResponseError } from '@/http/parsers/parse_response';
import LoadingContent from '@/components/LoadingContent.vue';
import service from '@/services/finance-service';

export default {
  name: 'DetailsSectionClaimInformation',
  components: {
    LoadingContent,
    FinancialList,
  },
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.CLAIM_TRANSACTIONS_TABLE_HEADERS = [
      associateHeaderDataItem(this.translations.claim_transaction_table.from_date, 'from_date'),
      associateHeaderDataItem(this.translations.claim_transaction_table.to_date, 'to_date'),
      associateHeaderDataItem(this.translations.claim_transaction_table.pos, 'pos'),
      associateHeaderDataItem(this.translations.claim_transaction_table.cpt, 'cpt_code'),
      associateHeaderDataItem(this.translations.claim_transaction_table.modifier, 'modifier'),
      associateHeaderDataItem(this.translations.claim_transaction_table.charges, 'charges'),
      associateHeaderDataItem(this.translations.claim_transaction_table.quantity, 'quantity'),
    ];
  },
  data() {
    return {
      translations: translations.finance_operations.claims_follow_up_tasks.details.section_claim_information,
      claimInformation: {},
      claimTransactionTable: [],
      allLoaded: false,
      hasClaim: true,
    };
  },
  async beforeMount() {
    this.hasClaim = this.details.claim?.id > 0;
    let loaded = true;
    if (this.hasClaim) {
      loaded = await this.fetchClaimInformation();
    }
    if (loaded) {
      this.allLoaded = true;
    }
  },
  methods: {
    async fetchClaimInformation() {
      try {
        this.claimInformation = {};
        this.claimTransactionTable = [];

        const response = await service.getClaimInformation(this.details.claim.id);
        const claimInformation = response.data;

        this.claimInformation = {
          ...claimInformation,
          dob: formatDate(claimInformation.dob),
          submitted_date: formatDate(claimInformation.submitted_date),
          billed_amount: formatValue(claimInformation.billed_amount),
          paid_amount: formatValue(claimInformation.paid_amount),
        };

        this.claimTransactionTable = claimInformation?.claim_transactions?.map(transaction => ({
          ...transaction,
          from_date: formatDate(transaction.from_date),
          to_date: formatDate(transaction.to_date),
          charges: formatValue(transaction.charges),
          quantity: 1,
        }));
        return true;
      } catch (err) {
        const errMsg = `${this.translations.error_fetching_claim}: ${parseResponseError(err)}`;
        this.$noty.error(errMsg);
        return false;
      }
    },
  },
};
</script>
